const keyFacets = [
	{ id: 'C' },
	{ id: 'C#m/Dbm' },
	{ id: 'Cm' },
	{ id: 'D' },
	{ id: 'Db/C#' },
	{ id: 'Dm' },
	{ id: 'E' },
	{ id: 'Eb/D#' },
	{ id: 'Ebm/D#m' },
	{ id: 'Em' },
	{ id: 'F' },
	{ id: 'F#m/Gbm' },
	{ id: 'Fm' },
	{ id: 'G' },
	{ id: 'G#m/Abm' },
	{ id: 'Gb/F#' },
	{ id: 'Gm' },
	{ id: 'A' },
	{ id: 'Ab/G#' },
	{ id: 'Am' },
	{ id: 'B' },
	{ id: 'Bb/A#' },
	{ id: 'Bbm/A#m' },
	{ id: 'Bm' },
	{ id: 'N/A' },
]

export default keyFacets
